module.exports = __webpack_public_path__ + "ua.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ua.svg
// module id = 862
// module chunks = 0